import React from 'react'
import { FilterNonprofitsProps } from './filter-non-profits.constants'
import { useFilterNonprofitsStyles } from './filter-non-profits.styles'
import { useTranslation } from 'react-i18next'
import {
  Button,
  Card,
  CardContent,
  FormControl,
  SwipeableDrawer,
  TextField,
} from '@material-ui/core'
import Autocomplete from '@material-ui/lab/Autocomplete'
import CloseIcon from '@material-ui/icons/Close'
import { ScreenSize } from '../../settings/device'
import { useFilterNonprofitsHook } from './filter-non-profits.hooks'
import { FilterOpenButton } from '../filter-open-button'

enum InputNames {
  Text = 'search',
}

export const FilterNonprofits: React.FC<FilterNonprofitsProps> = (props: FilterNonprofitsProps) => {
  const classes = useFilterNonprofitsStyles()
  const { t } = useTranslation()

  const {
    //props
    searchText,
    screenSize,
    loading,
    cancelHandler,
    categories,
    nonprofitCategoryId,
    settings = {},
    btnDisabled,

    //methods
    handleChangeCategoryHandler,
    searchTextFieldBlurHandler,
    searchTextFieldEnterHandler,
    searchTextFieldFocusHandler,
    handleSearchTextHandler,
    applyBtnHandler,
    toggleDrawer,

    //state
    drawerStatus,
  } = useFilterNonprofitsHook({
    ...props,
  })

  const { hideCategory } = settings

  const filterWrapper = () => {
    return (
      <CardContent
        id="filter-card-content"
        className={`${
          screenSize === ScreenSize.Mobile ? classes.filterWrapper : ''
        }`}
      >
        {
          <div className={`${classes.filterBody}`}>
            {screenSize !== ScreenSize.Desktop && (
              <span className={classes.closeBtn} onClick={toggleDrawer(false)}>
                <CloseIcon />
              </span>
            )}

            <div
              className={
                screenSize === ScreenSize.Desktop
                  ? classes.searchTextHolder
                  : classes.searchTextHolderMobile
              }
            >
              <FormControl variant="outlined" fullWidth>
                <TextField
                  label={t('filter.searchFormLabel')}
                  name={InputNames.Text}
                  value={searchText}
                  disabled={loading}
                  id={'filter-searchText'}
                  fullWidth
                  variant="outlined"
                  inputProps={{ 'data-testid': 'search' }}
                  onChange={(e) => handleSearchTextHandler(e.target.value)}
                  onFocus={() => searchTextFieldFocusHandler()}
                  onBlur={() => searchTextFieldBlurHandler()}
                  onKeyUpCapture={(e) => searchTextFieldEnterHandler(e)}
                />
              </FormControl>
            </div>

            {!hideCategory && (
              <div
                className={classes.lookupHolderCategory}
                id="filter-category-wrapper"
              >
                <FormControl variant="outlined" fullWidth>
                  <Autocomplete
                    value={
                      categories.filter(
                        (item: any) =>
                          item!.nonprofitCategoryId! === nonprofitCategoryId
                      )[0] || null
                    }
                    id={'filter-categories'}
                    options={categories}
                    disabled={!categories.length || loading}
                    autoHighlight
                    getOptionLabel={(option) => option.name as string}
                    onChange={(e, value) => handleChangeCategoryHandler(value)}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label={t('filter.selectCategory')}
                        variant="outlined"
                        inputProps={{
                          ...params.inputProps,
                        }}
                      />
                    )}
                  />
                </FormControl>
              </div>
            )}

            {/* Mobile Mode */}
            {screenSize === ScreenSize.Mobile && (
              <div className={classes.buttonContainer}>
                <Button
                  variant="contained"
                  fullWidth
                  color="primary"
                  onClick={applyBtnHandler}
                  disabled={btnDisabled}
                >
                  {t('filter.apply')}
                </Button>
                <Button
                  variant="outlined"
                  fullWidth
                  color="primary"
                  disabled={btnDisabled}
                  onClick={cancelHandler}
                >
                  {t('filter.cancel')}
                </Button>
              </div>
            )}
          </div>
        }
        
      </CardContent>
    )
  }

  return (
    <>
      <Card className={classes.filterHolder} id="filter-card" elevation={0}>
        {screenSize !== ScreenSize.Desktop && (
          <FilterOpenButton onClick={toggleDrawer(true)} />
        )}
        {screenSize !== ScreenSize.Unknown &&
        screenSize === ScreenSize.Desktop ? (
          filterWrapper()
        ) : (
          <SwipeableDrawer
            id="filter-drawer"
            onClose={toggleDrawer(false)}
            onOpen={toggleDrawer(true)}
            open={drawerStatus}
            anchor="left"
            classes={{ paper: classes.drawerPaper }}
          >
            {filterWrapper()}
          </SwipeableDrawer>
        )}
      </Card>
    </>
  )
}
